import evaluateSegments from "../controllers/segmentos";
import setFloatingCards from "../animations/floatingCards";
import Remaining from "../components/remaining";

async function initSegments() {
  await evaluateSegments();
  setStyles();
  setFloatingCards();
  initToggleFloatingCards();
  Remaining();
  switchSkeleton();
}

function setStyles() {
  const $wall = document.querySelector("#wall");
  const styles = $wall.dataset.styles;
  $wall.classList.add(...styles.trim().split(" ").filter(Boolean));
}

function switchSkeleton() {
  const $segmentMain = document.querySelector("#segments");
  const $segmentSkeleton = document.querySelector("#segments-skeleton");
  const $segmentStyles = document.querySelector("#wall");

  $segmentStyles.classList.remove("segment-skeleton");
  $segmentSkeleton.style.display = "none";
  $segmentMain.style.display = "block";
}

function initToggleFloatingCards() {
  const paywallCardsCollapse = document.querySelector(
    ".paywall-cards-collapse"
  );
  const hiddenCard = document.querySelector(".hide-cards");

  window.addEventListener("scroll", () => {
    const rect = paywallCardsCollapse.getBoundingClientRect();

    if (rect.bottom <= 0) {
      hiddenCard.classList.remove("hide-cards");
    } else {
      hiddenCard.classList.add("hide-cards");
    }
  });
}
export default { initSegments };



// WEBPACK FOOTER //
// ./Statics/scripts/paywall/helpers/segments.js